import { useEffect, useState } from 'react';
import { API_BASE, BACKEND_URL } from '../config';

const SeoHead = () => {
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    if (applied) return;

    fetch(`${API_BASE}/settings`)
      .then(r => r.json())
      .then(settings => {
        if (!settings || !settings._id) return;

        // Title
        if (settings.siteTitle) {
          document.title = settings.siteTitle;
        }

        // Helper to set or create meta tag
        const setMeta = (attr, attrValue, content) => {
          if (!content) return;
          let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
          if (!el) {
            el = document.createElement('meta');
            el.setAttribute(attr, attrValue);
            document.head.appendChild(el);
          }
          el.setAttribute('content', content);
        };

        // Basic SEO
        setMeta('name', 'description', settings.metaDescription);
        setMeta('name', 'keywords', settings.metaKeywords);
        setMeta('name', 'robots', settings.robots || 'index, follow');
        setMeta('name', 'theme-color', settings.themeColor || '#2F2386');

        // Google verification
        if (settings.googleVerification) {
          setMeta('name', 'google-site-verification', settings.googleVerification);
        }

        // Open Graph
        setMeta('property', 'og:title', settings.ogTitle || settings.siteTitle);
        setMeta('property', 'og:description', settings.ogDescription || settings.metaDescription);
        setMeta('property', 'og:type', 'website');
        if (settings.canonicalUrl) {
          setMeta('property', 'og:url', settings.canonicalUrl);
        }
        if (settings.ogImage) {
          const ogImgUrl = settings.ogImage.startsWith('http')
            ? settings.ogImage
            : `${settings.canonicalUrl || window.location.origin}${settings.ogImage}`;
          setMeta('property', 'og:image', ogImgUrl);
        }

        // Twitter Card
        setMeta('name', 'twitter:card', settings.twitterCard || 'summary_large_image');
        if (settings.twitterSite) {
          setMeta('name', 'twitter:site', settings.twitterSite);
        }
        setMeta('name', 'twitter:title', settings.ogTitle || settings.siteTitle);
        setMeta('name', 'twitter:description', settings.ogDescription || settings.metaDescription);

        // Canonical URL
        if (settings.canonicalUrl) {
          let link = document.querySelector('link[rel="canonical"]');
          if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
          }
          link.setAttribute('href', settings.canonicalUrl);
        }

        // Favicon
        if (settings.favicon) {
          const faviconUrl = `${BACKEND_URL}${settings.favicon}`;
          let link = document.querySelector('link[rel="icon"]');
          if (link) {
            link.href = faviconUrl;
          } else {
            link = document.createElement('link');
            link.rel = 'icon';
            link.href = faviconUrl;
            document.head.appendChild(link);
          }
          // Also set apple-touch-icon
          let apple = document.querySelector('link[rel="apple-touch-icon"]');
          if (apple) {
            apple.href = faviconUrl;
          }
        }

        setApplied(true);
      })
      .catch(() => {});
  }, [applied]);

  return null;
};

export default SeoHead;
